import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative w-screen md:w-[32rem] min-h-screen md:min-h-0" }
const _hoisted_2 = { class: "bg-cebai-base-light h-full p-6" }
const _hoisted_3 = { class: "py-10 sm:p-5" }
const _hoisted_4 = { class: "max-w-md mx-auto" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "text-cebai-base-dark" }, " Let's finish setting up your account ", -1)
const _hoisted_6 = { class: "mt-12 sm:mt-8" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "block text-base font-robotoBold mb-2" }, " First name ", -1)
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "block text-base font-robotoBold mb-2" }, " Last name ", -1)
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "block text-base font-robotoBold mb-2" }, [
  /*#__PURE__*/_createTextVNode(" Job title "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-normal text-cebai-grey-dark" }, " (optional) ")
], -1)
const _hoisted_13 = { class: "flex items-center justify-center mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Editorial = _resolveComponent("Editorial")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Editorial, {
            align: "centre",
            class: "px-4"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputFirstName) = $event)),
                  type: "text",
                  class: "input w-full",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.inputFirstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputLastName) = $event)),
                  type: "text",
                  class: "input w-full",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.inputLastName]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputJobTitle) = $event)),
                  type: "text",
                  class: "input w-full"
                }, null, 512), [
                  [_vModelText, _ctx.inputJobTitle]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_AppButton, {
                  type: "primary",
                  size: "large",
                  disabled: _ctx.submitIsDisabled,
                  "is-loading": _ctx.isSavingProfile
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Save ")
                  ]),
                  _: 1
                }, 8, ["disabled", "is-loading"])
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}